import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
} from "@angular/forms";
import {
  Store,
  Actions,
  ofActionSuccessful,
  ofActionErrored,
} from "@ngxs/store";
import { UserState } from "src/app/states/user.state";

import {
  Login,
  GoogleLogin,
  FirebaseAuth,
} from "../../states/actions/user.actions";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { LoaderComponent } from "src/app/basic/loader/loader.component";
import { Navigate } from "@ngxs/router-plugin";
import { DataService } from "src/app/services/data.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  loader: MatDialogRef<LoaderComponent>;
  hide = true;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    private actions: Actions,
    private dialog: MatDialog,
    private _dataService: DataService
  ) {}

  ngOnInit() {
    const isGhost = this.store.selectSnapshot(UserState.isGhost);
    if (!!isGhost && !isGhost) {
      this.store.dispatch(new Navigate(["/account"]));
    } else {
      this.loginForm = this.fb.group({
        email: [null, [Validators.required, Validators.email]],
        password: [null, [Validators.required]],
      });
    }
  }

  login = () => {
    this._dataService.displayLoading();
    this.handlerLogin(Login);
    this.store.dispatch(new Login(this.loginForm.value));
  };

  handler = (action, msg?, err = "Error de conexión") => {
    this.actions.pipe(ofActionSuccessful(action)).subscribe(() => {
      this._dataService.displayLoading(false);
    });
    this.actions.pipe(ofActionErrored(action)).subscribe(() => {
      this._dataService.displayLoading(false);
    });
  };
  handlerLogin = (action, msg?, err = "Error de conexión") => {
    this.actions.pipe(ofActionSuccessful(action)).subscribe(() => {
      this._dataService.displayLoading(false);
      location.reload();
    });
    this.actions.pipe(ofActionErrored(action)).subscribe(() => {
      this._dataService.displayLoading(false);
    });
  };

  register = () => {
    window.location.replace("https://tavuel.com/login/newShopUser");
  };

  google = () => {
    const loader = this.dialog.open(LoaderComponent, {
      maxWidth: "none",
      height: "100vw",
      width: "100vw",
      hasBackdrop: true,
      panelClass: "loader-dialog",
      disableClose: true,
    });
    this.store.dispatch(new GoogleLogin(loader));
    this.handler(FirebaseAuth, loader);
  };
}
